import React from 'react'
import HeroSection from '../Components/home4/HeroSection'
import TechServicesSection from '../Components/home4/TechServicesSection'
import LatestInsightsSection from '../Components/home4/LatestInsightsSection'
import ClientsCareersSection from '../Components/home4/ClientsCareersSection'
import DemoFooter from '../Components/home4/DemoFooter'
import DemoHeader from '../Components/home4/DemoHeader'
// import HeroSection from '../Components/home/HeroSection'
// import TechServicesSection from '../Components/home/TechServicesSection'
// import LatestInsightsSection from '../Components/home/LatestInsightsSection'
// import ClientsCareersSection from '../Components/home/ClientsCareersSection'

function Home4() {
  return (
    <div>
      <DemoHeader />
      <HeroSection />
      <TechServicesSection />
      <LatestInsightsSection />
      <ClientsCareersSection />
      <DemoFooter />
    </div>
  )
}

export default Home4
